import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Popconfirm,
  Row,
  Select,
  Space,
  Typography,
  notification,
} from 'antd';
import ja_JP from 'antd/lib/date-picker/locale/ja_JP';
import TextArea from 'antd/lib/input/TextArea';
import { Footer } from 'antd/lib/layout/layout';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  // Link,
  useHistory,
} from 'react-router-dom';
import { Session } from '../../common/objectType/Session';
import { SessionValues } from '../../common/compornents/SessionValues';
import { Message } from '../../common/constants/Message';
import { JuchuData } from '../../common/objectType/JuchuData';
import { JuchuDetailData } from '../../common/objectType/JuchuDetailData';
import { generateMessage } from '../../common/util/MessageUtil';
import NonyusakiSearch from '../../pages/nonyusakiSearch/NonyusakiSearch';
import CustomerSearch from '../../pages/tokuisaki/CustomerSearch';
import JuchuNyuryokuServ from '../../services/JuchuNyuryokuServ';
import JuchuNyuryokuDetail from './JuchuNyuryokuDetail';
import {
  checkDateData,
  DeletedJuchuData,
  ExistenceJuchuData,
  ExistenceKojiNo,
  RequiredHeaders,
  RequiredDetailsCnt,
  SystemError,
  UpdatedJuchuData,
} from './Validation';
import { Const } from '../../common/constants/Constants';
import { notificationError, notificationInfo } from '../../common/compornents/notification';
import JuchuShokaiModal from '../JuchuShokai/JuchuShokaiModal';

interface IProps {
  displayFlg: boolean;
  loading: boolean;
  changeLoading: (data: any) => void;
}

// 処理選択データ
const shoriSentakuData = [
  { seq: Const.SHORI_KBN.Create, value: '新規' },
  { seq: Const.SHORI_KBN.Edit, value: '修正' },
  { seq: Const.SHORI_KBN.Delete, value: '削除' },
  { seq: Const.SHORI_KBN.Show, value: '照会' },
];

const JuchuNyuryokuMain: React.FC<IProps> = (props: IProps) => {
  // セッション情報
  let session: Session = SessionValues();

  // 部品の設定
  const { Option } = Select;
  let history = useHistory();

  // 画面全体のstate
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  // 納入先コンボボックスソース
  const [nonyusakiDataOptions, updateNonyusakiDataOption] = useState<any[]>([]);
  // ユーザーコンボボックスソース
  const [userDataOptions, updateUserDataOptions] = useState<any[]>([]);
  // 受注情報
  const [juchuData, updateJuchuData] = useState<JuchuData>({} as JuchuData);
  // 受注明細一覧情報
  const [juchuListData, updateJuchuListData] = useState<JuchuDetailData[]>([]);
  // 受注明細データ
  const [juchuDetailData, updateJuchuDetailData] = useState<JuchuDetailData>({} as JuchuDetailData);
  const [dispJuchuDetailData, updateDispJuchuDetailData] = useState<JuchuDetailData>(
    {} as JuchuDetailData
  );

  // 受注明細削除情報
  const [juchuListDelData, updateJuchuListDelData] = useState<any[]>([]);
  // 納入先ポップアップ
  const [nonyuSaki, updateNonyuSaki] = useState<number>();
  const [nonyusakiPop, updateNonyusakiPop] = useState(false);
  // ユーザーポップアップ
  const [user, updateUser] = useState<string[]>([]);
  const [userPop, updateUserPop] = useState(false);
  // 顧客用受注照会ポップアップ
  const [juchuShokaiPop, updateJuchuShokaiPop] = useState(false);
  // 処理選択
  const [shoriSentaku, updateShoriSentaku] = useState<string>(Const.SHORI_KBN.Create);
  const [disabledShoriSentaku, updatedisabledShoriSentaku] = useState<boolean>(false);
  // クリア処理フラグ
  const [clearFlg, updateClearFlg] = useState<boolean>(false);

  // 初期処理
  useEffect(() => {
    const init = async () => {
      form.setFieldsValue({
        jyuDt: moment().format('YYYY/MM/DD'),
        shoriSentaku: session.jyuNo ? Const.SHORI_KBN.Show : Const.SHORI_KBN.Create,
        userCompanyName: session.companyName,
        userTantosya: session.tanName,
      });
      if (session.jyuNo) {
        let result: boolean = await SelJuchuData();
        if (result === true) {
          SelJuchuListData();
        } else {
          form.setFieldsValue({ jyuDt: '', jyuNo: session.jyuNo });
        }
      } else {
        await SelAccountData();
      }
      updateShoriSentaku(form.getFieldValue('shoriSentaku'));
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 受注データ変更処理
  useEffect(() => {
    if (juchuData !== undefined && Object.keys(juchuData).length > 0) {
      /**
       * この部分でjuchuDataから納入先CDを画面にセットしているため、
       * 受注データ.納入先CDはマイナス値のままjuchuDataに保持する
       * （絶対値で保持すると受注データ.納入先CDの判断がつかなくなってしまう）
       */
      form.setFieldsValue({
        nouCd: juchuData.nouCd,
        kojiNm: juchuData.kojiNm,
        nouAddress: `${juchuData.kenNm || ''}${juchuData.siNm || ''}${juchuData.adrTyo || ''}${
          juchuData.adrBan || ''
        }`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [juchuData]);

  // 納入先ポップから遷移
  useEffect(() => {
    if (nonyuSaki && nonyusakiPop === false) {
      nounyusakiUpdate(nonyuSaki);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nonyuSaki]);

  // ユーザーポップから遷移
  useEffect(() => {
    if (user !== undefined && user.length > 0) {
      SelUserList(juchuData.tokCd, juchuData.tokCd2);
      if (user.length !== 0 && userPop === false) {
        userUpdate(user);
        form.setFieldsValue({ userNm: [user[0], user[1]].join('.') });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // 受注照会画面ポップアップから遷移
  useEffect(() => {
    const init = async () => {
      if (session.jyuNo.length > 0) {
        if (juchuShokaiPop === false) {
          let tmpOption = await SelNonyusakiList(session.tokCd, session.tokCd2, session.jyuNo);
          // ダブルクリックで遷移してきたとき
          // 注文番号に変化があるか確認
          if (session.moveKbn === '1') {
            form.setFieldsValue({
              shoriSentaku: Const.SHORI_KBN.Show,
              jyuNo: session.jyuNo,
            });
            let result: boolean = await SelJuchuData(tmpOption);
            if (result === true) {
              SelJuchuListData();
            } else {
              form.setFieldsValue({ jyuDt: '', jyuNo: session.jyuNo });
            }
            updateShoriSentaku(form.getFieldValue('shoriSentaku'));
          }
          //  照会モードで受注照会画面ポップアップへ遷移するとき
        } else if (juchuShokaiPop === true) {
          sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.MOVE_KBN, '0');
        }
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [juchuShokaiPop]);

  // 希望納期入力制限
  const disabledDate = (current: any) => {
    return current && current < moment().add(-1, 'day');
  };

  // 納入先コンボボックスソース
  const SelNonyusakiList = async (tok_cd: string, tok_cd2: string, jyuNo: string) => {
    let resultArray: any[] = [];
    await JuchuNyuryokuServ.selNonyusakiList(tok_cd, tok_cd2, jyuNo)
      .then(async (json) => {
        updateNonyusakiDataOption(json.data);
        resultArray = json.data;
      })
      .catch((error) => {
        notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先検索'));
      });
    return resultArray;
  };

  // ユーザーコンボボックスソース
  const SelUserList = async (tok_cd: string, tok_cd2: string) => {
    await JuchuNyuryokuServ.selUserList(tok_cd, tok_cd2)
      .then((json) => {
        updateUserDataOptions(json.data);
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, 'ユーザー検索')
        );
      });
  };

  // アカウントデータ
  const SelAccountData = async () => {
    await JuchuNyuryokuServ.selAccountData(session.companyCd, session.accountId)
      .then(async (json) => {
        await SelNonyusakiList(session.tokCd, session.tokCd2, '');
        await SelUserList(session.tokCd, session.tokCd2);
        form.setFieldsValue({
          // nameとentityの名前が一緒なら展開できる
          ...json.data,
          // 特別なことをしたければ特記する
          tokCd: session.tokCd,
          tokCd2: session.tokCd2,
        });
        updateJuchuData((juchuData) => {
          return { ...juchuData, tokCd: session.tokCd, tokCd2: session.tokCd2 };
        });
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, 'アカウントデータ検索')
        );
      });
  };

  // 受注データ
  const SelJuchuData = async (nonyusakiDataOptions: any[] = []): Promise<boolean> => {
    let result: boolean = false;
    await JuchuNyuryokuServ.selJuchuData(session.jyuNo)
      .then(async (json) => {
        if (json.data !== '') {
          /**
           * 納入先ドロップダウンリストのデータでは、
           * 受注データの納入先CDに対応する納入先CDがマイナス値で取得されるため、
           * 受注データ.納入先CDをマイナス値に変換する。
           */
          let juchuNonyuCd: number = json.data['nouCd'];
          let tmpItem = nonyusakiDataOptions.find(
            (item) =>
              Number(item.seq) === (Number(juchuNonyuCd) > 0 ? juchuNonyuCd * -1 : juchuNonyuCd)
          );
          await SelUserList(json.data['tokCd'], json.data['tokCd2']);
          updateJuchuData({
            ...json.data,
            nouCd: tmpItem !== undefined ? tmpItem.seq : juchuNonyuCd,
            juchuNouNm: json.data['nouNm'],
          });
          form.setFieldsValue({
            // nameとentityの名前が一緒なら展開できる
            ...json.data,
            // 特別なことをしたければ特記する
            jyuDt: checkDateData(json.data['jyuDt'])
              ? moment(json.data['jyuDt']).format('YYYY/MM/DD')
              : undefined,
            kiboDt: checkDateData(json.data['kiboDt']) ? moment(json.data['kiboDt']) : undefined,
            tokkaFlg: Number(json.data['tokkaFlg']),
            chartFlg: Number(json.data['chartFlg']),
            nouCd: tmpItem !== undefined ? tmpItem.seq : juchuNonyuCd, //  > 0
          });
          updatedisabledShoriSentaku(false);
          result = true;
        } else {
          notificationInfo('注文入力', Message.INFO_MASSAGE.INF004);
          updatedisabledShoriSentaku(true);
        }
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, '受注データ検索')
        );
      });
    return result;
  };

  // 受注明細一覧データ
  const SelJuchuListData = () => {
    JuchuNyuryokuServ.selJuchuListData(session.tokCd, session.tokCd2, session.jyuNo)
      .then((json) => {
        updateJuchuListData(json.data);
        // 明細データのクリア
        updateClearFlg(true);
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, '受注明細データ検索')
        );
      });
  };

  // 納入先を変更
  const nounyusakiUpdate = async (seq: number) => {
    // 受注データ.納入先CDを選択した場合は、納入先CDがマイナス値であるため絶対値を取得

    let selServ =
      seq === 0
        ? JuchuNyuryokuServ.selYukoTokuisaki(session.tokCd, session.tokCd2)
        : JuchuNyuryokuServ.selYukoNonyusaki(session.tokCd, session.tokCd2, Math.abs(seq));

    await selServ
      .then((json) => {
        updateJuchuData({
          ...juchuData,
          nouCd: seq,
          nouNm: seq < 0 ? juchuData.juchuNouNm : json.data['tokNm'],
          adrKenCd: json.data['adrKenCd'],
          adrSiCd: json.data['adrSiCd'],
          kenNm: json.data['adrKen'],
          siNm: json.data['adrSi'],
          adrTyo: json.data['adrTyo'],
          adrBan: json.data['adrBan'],
          nonyuTel: json.data['telNo'],
          nonyuYubin: json.data['yubinNo'],
        });
      })
      .catch((error) => {
        notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先検索'));
      });
    updateNonyuSaki(seq);
  };

  // 工事管理番号を変更
  const kojiNmUpdate = () => {
    let kojiNo = form.getFieldValue('kojiNo');
    JuchuNyuryokuServ.selKojiNo(kojiNo, session.tokCd, session.tokCd2)
      .then((json) => {
        updateJuchuData({
          ...juchuData,
          kojiNm: json.data['kojiNm'],
          kojiNo: kojiNo,
        });
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, '工事管理番号検索')
        );
      });
  };

  // ユーザーを変更
  const userUpdate = (user: string[]) => {
    updateJuchuData({
      ...juchuData,
      userCd: user[0],
      userCd2: user[1],
      userNm:
        userDataOptions.find(
          (item) => [item.tokCd, item.tokCd2].join('.') === [user[0], user[1]].join('.')
        )?.tokNm || '',
    });
  };

  // 納入先ポップを開く
  const showNonyusakiPop = () => {
    updateNonyuSaki(form.getFieldValue('nouCd'));
    updateNonyusakiPop(true);
  };

  // 納入先ポップを閉じる
  const closeNonyusakiPop = async () => {
    // 納入先リスト再検索
    updateNonyusakiPop(false);
    await SelNonyusakiList(juchuData.tokCd, juchuData.tokCd2, juchuData.jyuNo);
  };

  // ユーザーポップを開く
  const showUserPop = () => {
    updateUserPop(true);
  };

  // ユーザーポップを閉じる
  const closeUserPop = () => {
    // userUpdate(user);
    updateUserPop(false);
  };

  // 受注照会ポップを開く
  const showJuchuShokaiPop = () => {
    updateJuchuShokaiPop(true);
  };

  // 受注照会ポップを閉じる
  const closeJuchuShokaiPop = () => {
    updateJuchuShokaiPop(false);
  };

  // 確定ボタン処理
  const SubmitButton = async () => {
    if (props.loading) return;
    props.changeLoading(true);
    let headerData: JuchuData;
    headerData = { ...form.getFieldsValue() };
    if (shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit) {
      if (RequiredHeaders(juchuData.nouCd)) {
        if (RequiredDetailsCnt(juchuListData)) {
          let result: any;
          result = await JuchuNyuryokuServ.clickKakutei(
            session.jishaKbn,
            shoriSentaku,
            session.companyCd,
            session.accountId,
            session.tokCd,
            session.tokCd2,
            juchuData,
            juchuListData,
            juchuListDelData,
            headerData
          );
          if (result.data['rsltCd'] === 'SUCCESS' && shoriSentaku === Const.SHORI_KBN.Create) {
            result = await JuchuNyuryokuServ.clickKakuteiAto(
              session.jishaKbn,
              shoriSentaku,
              session.companyCd,
              session.accountId,
              session.tokCd,
              session.tokCd2,
              juchuData,
              juchuListData,
              result.data,
              session.tanName
            );
          }
          if (shoriSentaku === Const.SHORI_KBN.Create) {
            if (SubmitCheck(result)) {
              ClearButton();
              notification.success({
                message: generateMessage(Message.INFO_MASSAGE.INF003, result.data['jyuNo']),
                style: { whiteSpace: 'pre-line' },
              });
            }
          } else if (shoriSentaku === Const.SHORI_KBN.Edit) {
            if (SubmitCheck(result)) {
              ClearButton();
              history.push('/juchuShokai/1');
            }
          }
        }
      }
    } else if (shoriSentaku === Const.SHORI_KBN.Delete) {
      let result = await JuchuNyuryokuServ.clickKakutei(
        session.jishaKbn,
        shoriSentaku,
        session.companyCd,
        session.accountId,
        session.tokCd,
        session.tokCd2,
        juchuData,
        juchuListData,
        juchuListDelData,
        headerData
      );
      if (SubmitCheck(result)) {
        ClearButton();
        history.push('/juchuShokai/1');
      }
    }
    props.changeLoading(false);
  };

  // 確定処理結果確認
  const SubmitCheck = (resultCode: any) => {
    let result: boolean = true;
    if (resultCode.data['rsltCd'] === undefined || resultCode.data['rsltCd'] === null) {
      SystemError('確定処理');
      result = false;
    } else if (resultCode.data['rsltCd'] === 'ERR011') {
      ExistenceKojiNo();
      result = false;
    } else if (resultCode.data['rsltCd'] === 'ERR012') {
      ExistenceJuchuData();
      result = false;
    } else if (resultCode.data['rsltCd'] === 'ERR013') {
      DeletedJuchuData();
      result = false;
    } else if (resultCode.data['rsltCd'] === 'ERR016') {
      UpdatedJuchuData();
      result = false;
    } else if (resultCode.data['rsltCd'] === 'ERR999') {
      SystemError('確定処理');
      result = false;
    }
    return result;
  };

  // クリアボタン処理
  const ClearButton = async () => {
    // 画面表示
    form.resetFields();
    // 内部データ
    updateJuchuData({} as JuchuData);
    updateJuchuListData([]);
    updateJuchuListDelData([]);
    // 入処理選択
    updateShoriSentaku(Const.SHORI_KBN.Create);
    // 納入先ポップアップ
    updateNonyuSaki(undefined);
    // ユーザーポップアップ
    updateUser([]);
    // 明細データのクリア
    updateClearFlg(true);
    // アカウントデータ取得
    await SelAccountData();
    // 初期状態をセット
    form.setFieldsValue({
      jyuDt: moment().format('YYYY/MM/DD'),
      shoriSentaku: Const.SHORI_KBN.Create,
      userCompanyName: session.companyName,
      userTantosya: session.tanName,
    });
  };

  // 処理選択変更
  const ChangeShoriSentaku = () => {
    updateShoriSentaku(form.getFieldValue('shoriSentaku'));
    form2.resetFields();
    if (session.jishaKbn === '0') {
      updateJuchuData({
        ...juchuData,
        jyuNo: '',
      });
      form.setFieldsValue({ jyuNo: '' });
    }
    updateJuchuDetailData({} as JuchuDetailData);
    updateJuchuListDelData([]);
  };

  // JSX
  return (
    <>
      <JuchuShokaiModal visibleState={juchuShokaiPop} CloseJuchuShokaiModal={closeJuchuShokaiPop} />
      <CustomerSearch
        tok_cd={session.tokCd}
        tok_cd2={session.tokCd2}
        yobidashimotoKbn="2"
        val={user}
        setVal={updateUser}
        visible={userPop}
        setVisible={closeUserPop}
      />
      <NonyusakiSearch
        tokCd={session.tokCd}
        tokCd2={session.tokCd2}
        visibleState={nonyusakiPop}
        closeNonyusakiSearch={closeNonyusakiPop}
        nonyuSaki={nonyuSaki}
        updateNonyusaki={updateNonyuSaki}
      />
      <Form
        form={form}
        layout="horizontal"
        autoComplete="off"
        style={{
          backgroundColor: '#d6e4ff',
        }}
      >
        {/* 処理選択からご担当者まで */}
        <div style={{ backgroundColor: '#d6e4ff', display: props.displayFlg ? '' : 'none' }}>
          <Row style={{ paddingTop: '1vh' }}>
            <Col style={{ left: 40 }} xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item label="処理選択"></Form.Item>
            </Col>
            <Col xxl={1} xl={2} lg={1} md={1} sm={1} xs={1}>
              <Form.Item name={'shoriSentaku'}>
                <Select
                  onChange={ChangeShoriSentaku}
                  disabled={
                    shoriSentaku === Const.SHORI_KBN.Create ||
                    shoriSentaku === Const.SHORI_KBN.Edit ||
                    shoriSentaku === Const.SHORI_KBN.Delete ||
                    (shoriSentaku === Const.SHORI_KBN.Show && disabledShoriSentaku === true)
                  }
                  notFoundContent=" "
                >
                  {shoriSentakuData
                    .filter((item) => {
                      if (session.jishaKbn === '0') {
                        if ([Const.SHORI_KBN.Create, Const.SHORI_KBN.Show].includes(item.seq)) {
                          return true;
                        }
                        return false;
                      } else if (session.jishaKbn === '1') {
                        if (
                          [
                            Const.SHORI_KBN.Edit,
                            Const.SHORI_KBN.Delete,
                            Const.SHORI_KBN.Show,
                          ].includes(item.seq)
                        ) {
                          return true;
                        }
                        return false;
                      } else if (!form.getFieldValue('tokCd')) {
                        if ([Const.SHORI_KBN.Create].includes(item.seq)) {
                          return true;
                        }
                        return false;
                      } else return true;
                    })
                    .map((item, index) => {
                      return (
                        <Option key={index} value={item.seq}>
                          {item.value}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col
              xxl={{ offset: 2, span: 3 }}
              xl={{ offset: 1, span: 4 }}
              offset={2}
              lg={3}
              md={3}
              sm={3}
              xs={3}
            >
              <Form.Item
                name={'jyuNo'}
                label={
                  session.jishaKbn === '0' ? (
                    <Typography.Link
                      onClick={() => {
                        session.jishaKbn === '0'
                          ? showJuchuShokaiPop()
                          : history.push('/juchuShokai/1');
                      }}
                    >
                      注文番号
                    </Typography.Link>
                  ) : (
                    '注文番号'
                  )
                }
              >
                <Input className="clsReadOnly" maxLength={10} readOnly />
              </Form.Item>
            </Col>
            <Col offset={1} xxl={1} xl={2} lg={1} md={1} sm={1} xs={1}>
              <Form.Item label="注文日"></Form.Item>
            </Col>
            <Col
              // style={{ width: 100 }}
              xxl={2}
              xl={2}
              lg={2}
              md={2}
              sm={2}
              xs={2}
            >
              <Form.Item name={'jyuDt'}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
            <Col
              // style={{ width: 615 }}
              xxl={7}
              xl={5}
              lg={7}
              md={7}
              sm={7}
              xs={7}
            >
              <Form.Item name={'userCompanyName'}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
            <Col offset={-1} xxl={4} xl={3} lg={4} md={4} sm={4} xs={4}>
              <Form.Item name={'userTantosya'}>
                <Input readOnly className="clsReadOnly" />
              </Form.Item>
            </Col>
          </Row>
          {/* お客様から弊社担当まで */}
          <Row>
            <Col style={{ left: 40 }} xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item label="お客様"></Form.Item>
            </Col>
            <Col xxl={1} xl={2} lg={1} md={1} sm={1} xs={1}>
              <Form.Item name={'tokCd'}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
            <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}>
              <Form.Item name={JuchuData.FIELD_KEY_NAME.tokCd2}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
              <Form.Item name={'tokNm'}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
            <Col offset={1} xxl={1} xl={2} lg={1} md={1} sm={1} xs={1}>
              <Form.Item label="弊社担当"></Form.Item>
            </Col>
            <Col xxl={4} xl={5} lg={4} md={4} sm={4} xs={4}>
              <Form.Item name={'ktnNm'}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
            <Col xxl={4} xl={2} lg={4} md={4} sm={4} xs={4}>
              <Form.Item name={'tanNm'}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
            <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item name={'telNo'}>
                <Input className="clsReadOnly" readOnly />
              </Form.Item>
            </Col>
          </Row>
          {/* 納入先 */}
          <Row>
            <Col style={{ left: 40 }} xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item
                name="nouCd"
                label={
                  shoriSentaku === Const.SHORI_KBN.Create ||
                  shoriSentaku === Const.SHORI_KBN.Edit ? (
                    <Typography.Link onClick={showNonyusakiPop}>納入先</Typography.Link>
                  ) : (
                    '納入先'
                  )
                }
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
              ></Form.Item>
            </Col>
            <Col xxl={8} xl={7} lg={8} md={8} sm={8} xs={8}>
              <Form.Item
                name="nouCd"
                rules={[
                  {
                    required: true,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR001, '納入先'),
                  },
                ]}
              >
                <Select
                  onSelect={(e: any) => nounyusakiUpdate(e)}
                  disabled={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                  notFoundContent=" "
                >
                  {nonyusakiDataOptions.map((item, index) => {
                    return (
                      <Option key={index} value={item.seq}>
                        {item.tokNm}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col offset={-1} xxl={13} xl={13} lg={13} md={13} sm={13} xs={13}>
              <Form.Item name={'nouAddress'}>
                <Input className="clsReadOnly" readOnly={true} />
              </Form.Item>
            </Col>
          </Row>
          {/* お客様注文No.から連絡メモ */}
          <Row>
            <Col style={{ left: 40 }} xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item
                label="お客様注文No"
                name={'ttyumonNo'}
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: '',
                  },
                ]}
              ></Form.Item>
              <Form.Item label="工事管理番号"></Form.Item>
            </Col>
            <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
              <Form.Item
                name={'ttyumonNo'}
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR017, 'お客様注文No'),
                  },
                ]}
              >
                <Input
                  className={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? ''
                      : 'clsReadOnly'
                  }
                  maxLength={15}
                  readOnly={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                />
              </Form.Item>
              <Form.Item
                name={'kojiNo'}
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR017, '工事管理番号'),
                  },
                ]}
              >
                <Input
                  maxLength={15}
                  onBlur={kojiNmUpdate}
                  readOnly={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                  className={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? ''
                      : 'clsReadOnly'
                  }
                />
              </Form.Item>
            </Col>
            <Col xxl={4} xl={5} lg={4} md={4} sm={4} xs={4}>
              {/* スタイル用 */}
              <Form.Item
                name={'ttyumonNo'}
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: '',
                  },
                ]}
              />
              <Form.Item name={'kojiNm'}>
                <Input className="clsReadOnly" readOnly={true} />
              </Form.Item>
            </Col>
            <Col offset={1} xxl={1} xl={2} lg={1} md={1} sm={1} xs={1}>
              <Form.Item label="連絡メモ"></Form.Item>
            </Col>
            <Col xxl={11} xl={10} lg={9}>
              <Form.Item name={'renMemo'}>
                <TextArea
                  rows={2}
                  maxLength={100}
                  readOnly={shoriSentaku === Const.SHORI_KBN.Create ? false : true}
                  className={shoriSentaku === Const.SHORI_KBN.Create ? '' : 'clsReadOnly'}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 希望納期から回答メモ */}
          <Row>
            <Col style={{ left: 40 }} xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item label="希望納期"></Form.Item>
              <Form.Item
                label={
                  shoriSentaku === Const.SHORI_KBN.Create ||
                  shoriSentaku === Const.SHORI_KBN.Edit ? (
                    <Typography.Link onClick={showUserPop}>ユーザー</Typography.Link>
                  ) : (
                    'ユーザー'
                  )
                }
              ></Form.Item>
            </Col>
            <Col xxl={4} xl={7} lg={4} md={4} sm={4} xs={4}>
              <Row>
                <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                  <Form.Item name={'kiboDt'}>
                    <DatePicker
                      locale={ja_JP}
                      format={'YYYY/MM/DD'}
                      disabledDate={disabledDate}
                      disabled={
                        shoriSentaku === Const.SHORI_KBN.Create ||
                        shoriSentaku === Const.SHORI_KBN.Edit
                          ? false
                          : true
                      }
                      style={{
                        backgroundColor:
                          shoriSentaku === Const.SHORI_KBN.Create ||
                          shoriSentaku === Const.SHORI_KBN.Edit
                            ? 'white'
                            : '#b5f5ec',
                        color: 'Bluck',
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                  <Form.Item name={'kiboKbn'}>
                    <Select
                      disabled={
                        shoriSentaku === Const.SHORI_KBN.Create ||
                        shoriSentaku === Const.SHORI_KBN.Edit
                          ? false
                          : true
                      }
                      allowClear
                      notFoundContent=" "
                    >
                      <Option value="1">AM</Option>
                      <Option value="2">PM</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item name={'userNm'}>
                <Select
                  onSelect={(e: any) => {
                    userUpdate(e.split('.'));
                  }}
                  disabled={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                  allowClear
                  notFoundContent=" "
                >
                  {userDataOptions.map((item, index) => {
                    return (
                      <Option key={index} value={[item.tokCd, item.tokCd2].join('.')}>
                        {item.tokNm}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col
              xxl={{ offset: 3, span: 1 }}
              xl={{ offset: 1, span: 2 }}
              offset={3}
              lg={1}
              md={1}
              sm={1}
              xs={1}
            >
              <Form.Item label="回答メモ"></Form.Item>
            </Col>
            <Col xxl={11} xl={10} lg={9}>
              <Form.Item name={'kaitoMemo'}>
                <TextArea
                  rows={2}
                  maxLength={100}
                  readOnly={shoriSentaku === Const.SHORI_KBN.Edit ? false : true}
                  className={shoriSentaku === Const.SHORI_KBN.Edit ? '' : 'clsReadOnly'}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 送り状メモ */}
          <Row>
            <Col style={{ left: 40 }} xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item label="送り状メモ"></Form.Item>
            </Col>
            <Col xxl={4} xl={7} lg={4} md={4} sm={4} xs={4}>
              <Form.Item name={'okuriMemo'}>
                <Input
                  maxLength={20}
                  readOnly={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                  className={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? ''
                      : 'clsReadOnly'
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 特価案件から配送メモまで */}
          <Row>
            <Col style={{ left: 40 }} xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
              <Form.Item label="特価案件"></Form.Item>
            </Col>
            <Col xxl={1} xl={1} lg={1}>
              <Form.Item name={'tokkaFlg'} valuePropName="checked">
                <Checkbox
                  checked
                  disabled={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xxl={{ offset: 2, span: 2 }}
              xl={{ offset: 3, span: 2 }}
              offset={2}
              lg={2}
              md={2}
              sm={2}
              xs={2}
            >
              <Form.Item label="チャーター希望" name={'chartFlg'} valuePropName="checked">
                <Checkbox
                  checked
                  disabled={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xxl={{ offset: 2, span: 1 }}
              xl={{ offset: 2, span: 2 }}
              offset={2}
              lg={1}
              md={1}
              sm={1}
              xs={1}
            >
              <Form.Item label="配送メモ"></Form.Item>
            </Col>
            <Col xxl={11} xl={10} lg={11} md={11} sm={11} xs={11}>
              <Form.Item name={'haisoMemo'}>
                <Input
                  maxLength={50}
                  readOnly={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? false
                      : true
                  }
                  className={
                    shoriSentaku === Const.SHORI_KBN.Create || shoriSentaku === Const.SHORI_KBN.Edit
                      ? ''
                      : 'clsReadOnly'
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        {/* 受注明細 */}
        <JuchuNyuryokuDetail
          session={session}
          juchuData={juchuData}
          juchuListlData={juchuListData}
          updateJuchuListData={updateJuchuListData}
          juchuDetailData={juchuDetailData}
          updateJuchuDetailData={updateJuchuDetailData}
          dispJuchuDetailData={dispJuchuDetailData}
          updateDispJuchuDetailData={updateDispJuchuDetailData}
          juchuListDelData={juchuListDelData}
          updateJuchuListDelData={updateJuchuListDelData}
          headerForm={form}
          detailForm={form2}
          shoriSentaku={shoriSentaku}
          nonyuSaki={nonyuSaki}
          clearFlg={clearFlg}
          updateClearFlg={updateClearFlg}
          loading={props.loading}
          changeLoading={props.changeLoading}
        />
        <Footer
          style={{
            backgroundColor: '#e6f7ff',
            // marginTop: "2vh",
            height: '90px',
          }}
        >
          <Row>
            <Col
              xxl={{ offset: 18 }}
              xl={{ offset: 16 }}
              lg={{ offset: 16 }}
              md={{ offset: 14 }}
              sm={{ offset: 12 }}
              xs={{ offset: 10 }}
              style={{
                position: 'fixed',
                bottom: '10px',
                paddingTop: '0px',
                paddingBottom: '30px',
                marginBottom: '5px',
                backgroundColor: '#d3adf7',
                width: '300px',
                zIndex: 999,
              }}
            >
              <Space size={'large'}>
                <Popconfirm
                  title={
                    shoriSentaku === Const.SHORI_KBN.Delete
                      ? Message.INFO_MASSAGE.INF001
                      : Message.INFO_MASSAGE.INF002
                  }
                  okText={'はい'}
                  cancelText={'いいえ'}
                  onConfirm={SubmitButton}
                  disabled={shoriSentaku === Const.SHORI_KBN.Show}
                >
                  <Button
                    type="primary"
                    size={'large'}
                    style={{
                      position: 'absolute',
                      left: '20px',
                      bottom: '5px',
                    }}
                    disabled={shoriSentaku === Const.SHORI_KBN.Show}
                  >
                    確 定
                  </Button>
                </Popconfirm>
                <Popconfirm
                  title={'入力した注文をクリアしますか？'}
                  okText={'はい'}
                  cancelText={'いいえ'}
                  onConfirm={ClearButton}
                  disabled={shoriSentaku !== Const.SHORI_KBN.Create}
                >
                  <Button
                    type="primary"
                    size={'large'}
                    style={{
                      position: 'absolute',
                      left: '110px',
                      bottom: '5px',
                    }}
                    disabled={shoriSentaku !== Const.SHORI_KBN.Create}
                  >
                    クリア
                  </Button>
                </Popconfirm>
                <Popconfirm
                  title={
                    session.jishaKbn === '0' ? '注文を終了しますか？' : '受注照会画面に戻りますか？'
                  }
                  okText={'はい'}
                  cancelText={'いいえ'}
                  onConfirm={() => {
                    session.jishaKbn === '0'
                      ? history.push('/login')
                      : history.push('/juchuShokai/1');
                  }}
                >
                  <Button
                    size={'large'}
                    type="primary"
                    style={{
                      position: 'absolute',
                      left: '210px',
                      bottom: '5px',
                    }}
                  >
                    {session.jishaKbn === '0' ? '終 了' : '戻 る'}
                  </Button>
                </Popconfirm>
              </Space>
            </Col>
          </Row>
        </Footer>
      </Form>
    </>
  );
};
export default JuchuNyuryokuMain;
